import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { EditIcon } from 'components/CustomSVG';
import { genderOptions } from 'helpers/customers';


const defaultCustomerGroups = [
  {
    code: 'Not Logged In',
    id: 0
  },
  {
    code: 'General',
    id: 1
  }
];

const CustomerRow = ({customerData, headTableCells}) => {
  const history = useHistory();
  const {
    entity_id,
    name,
    email,
    group_id,
    billing_street,
    billing_city,
    billing_telephone,
    billing_postcode,
    billing_region,
    created_at,
    created_in,
    dob,
    practice_name,
    gender,
    phone_number
  } = customerData;

  const [
    entity_idC,
    nameC,
    emailC,
    practice_nameC,
    group_idC,
    created_atC,
    billing_cityC,
    billing_regionC,
    billing_postcodeC,
    billing_fullC,
    billing_telephoneC,
    created_inC,
    dobC,
    genderC,
    detailsC,
  ] = headTableCells;

  const { customerGroups } = useSelector((state: IReduxState) => state.customers);
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';

  const code = [...defaultCustomerGroups, ...customerGroups].find((group) => group.id == group_id)?.code || '';

  return (
    <TableRow>
      {entity_idC.display && <TableCell>{entity_id}</TableCell>}
      {nameC.display && <TableCell>{name}</TableCell>}
      {emailC.display && <TableCell>{email}</TableCell>}
      {practice_nameC?.display && isCustomer3 && <TableCell>{practice_name || ''}</TableCell>}
      {group_idC.display && <TableCell>{code}</TableCell>}
      {created_atC.display && <TableCell>{new Date(created_at).toLocaleDateString('en-US', { timeZone: 'UTC' })}</TableCell>}
      {billing_cityC.display && <TableCell>{billing_city}</TableCell>}
      {billing_regionC.display && <TableCell>{billing_region}</TableCell>}
      {billing_postcodeC.display && <TableCell>{billing_postcode}</TableCell>}
      {billing_fullC.display &&
        <TableCell>
          {billing_street && billing_street !== 'none' &&
            `${billing_street} 
  ${billing_city}${billing_region.length ? ',' : ''} ${billing_region}${billing_postcode.length ? ',' : ''} ${billing_postcode}`}
        </TableCell>
      }
      {billing_telephoneC.display && <TableCell>{billing_telephone || phone_number || ''}</TableCell>}
      {created_inC.display && <TableCell>{created_in}</TableCell>}
      {dobC.display && <TableCell>{new Date(dob).toLocaleDateString('en-US', { timeZone: 'UTC' })}</TableCell>}
      {genderC.display && <TableCell>{genderOptions.find((g) => g.value == gender)?.name}</TableCell>}
      {detailsC.display &&
        <TableCell width="10%" align="center">
          <Tooltip title="Edit">
            <IconButton
              onClick={() => history.push(`/customers/${entity_id}/details`, { params: history.location.search })}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      }
    </TableRow>
  );
};

export default CustomerRow;
